import React, {useEffect} from 'react';
import Button from '@mui/material/Button';
import {AddRounded} from "@mui/icons-material";
import useSma from './useSma';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {fetchContentGroupByName} from "../../api/contentGroups";
import ImageCard from "../../components/Cards/components/ImageCard";
import ContentNavigator from "../../components/ContentNavigator";
import ContentView from "../../components/ContentView";

const SmaNavigator = ({ config }) => {
    return (
        <ContentNavigator topAction={
                        <Button
                            variant={'contained'}
                            color={'info'}
                            icon={<PlusOutlined />}
                            style={{ marginBottom: '15px', width: '100%' }}
                            onClick={config.onRequestSma}
                            className={'text-xl'}
                        >
                            Create an SMA
                        </Button>
                        }
                      sectionsConfig={config.sections}
                      linksConfig={config.linkConfig}

        />
    )
};


const SmaTemplates = ({onSubmit, onCreate}) => {
    const dispatch = useDispatch();
    const groups = useSelector((state) => state.contentGroups.groups?.smaTemplates); // Update as per your state structure
    const { initializeWithTemplate } = useSma();

    useEffect(() => {
        dispatch(fetchContentGroupByName('smaTemplates'))
    }, [dispatch]);

    const handleTemplateSelect = (template) => {
        const etfs = template?.fields?.etfs;
        const etfList = etfs.map(x=>{
            const [symbol, weight] = x.split(":");
            return { symbol, weight: parseFloat(weight) };
        });
        initializeWithTemplate(etfList);  // Create an SMA based on the template
        onSubmit?.();  // Callback after template selection (e.g., to navigate to a new view)
    };


    const handleRssClick = (link) => {
    };

    const config = {
        onRequestSma: onCreate,
        sections: [
            {
                title: "Key Concepts",
                items: [
                    {
                        title: "Taxes in Stock SMAs",
                        text: "Learn about the implications of taxes in single stock portfolios and how to capitalize on it",
                        onClick: () => window.open('https://storage.googleapis.com/resources.iaplatform.app/onePagers/Understanding%20Taxes%20in%20Strategies%20with%20Turnover.pdf')
                    },
                    {
                        title: "Hidden Risks in ETFs",
                        text: "Understand the risks associated with ETFs covering overlap, weight skew and more",
                    },
                ]
            },
        ],
        onRssLinkClick: handleRssClick,
        linkConfig: [
            {label: "Deans SMA Handbook", onClick: () => handleRssClick("Deans SMA Handbook")},
            {label: "Discussing SMAs with Clients", onClick: () => handleRssClick("Discussing SMAs with Clients")},
            {label: "The Art of Personalization", onClick: () => handleRssClick("The Art of Personalization")},
            {label: "Morning Blends with Rob", onClick: () => handleRssClick("Morning Blends with Rob")}
        ]
    };


    const ContentScroll = ()=>(
            <>
                {groups && Array.isArray(groups) && groups.map((template, index) => (
                    <ImageCard description={template?.fields?.description}
                               title={template?.fields?.name} imgUrl={template?.fields?.imgUrl}
                               action={
                                <Button startIcon={<AddRounded/>} variant={'outlined'} onClick={() => handleTemplateSelect(template)}>
                                    Start SMA
                                </Button>
                               }
                    />
                ))}
            </>
    )

    return <ContentView content={<ContentScroll/>} navigator={<SmaNavigator config={config}/> } />

};

export default SmaTemplates;
